import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62cb8349"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Chapters__Wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Chapters__Background color--5" }, null, -1))
const _hoisted_3 = { class: "Chapters__Header color--1" }
const _hoisted_4 = { class: "color--2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_ChapterItem = _resolveComponent("ChapterItem")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'course')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/courses",
          class: "Chapters__Overlay"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FocusTrap, {
      active: _ctx.state === 'course'
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "aside",
          onBeforeEnter: _ctx.onBeforeEnter,
          onAfterEnter: _ctx.onAfterEnter,
          onAfterLeave: _ctx.onAfterLeave
        }, {
          default: _withCtx(() => [
            (_ctx.state === 'course')
              ? (_openBlock(), _createElementBlock("aside", {
                  key: 0,
                  class: _normalizeClass(['Chapters', 'theme--'+_ctx.course.theme, _ctx.themeForceDark ? 'dark' : ''])
                }, [
                  _hoisted_2,
                  _createElementVNode("header", _hoisted_3, [
                    _createVNode(_component_ButtonClose, {
                      class: "Chapters__Close",
                      variant: _ctx.themeForceDark ? 'dark': 'light',
                      to: "/courses"
                    }, null, 8, ["variant"]),
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.courseTitle), 1),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('chapters.title')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["Chapters__Scroller", { 'is-touch': _ctx.isTouch }]),
                    ref: "scroller"
                  }, [
                    _createElementVNode("ul", {
                      class: "Chapters__List",
                      ref: "list",
                      style: _normalizeStyle(`transform: translateY(${-_ctx.currentRounded}px);`)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: chapter.slug,
                          class: "color--1"
                        }, [
                          _createVNode(_component_ChapterItem, {
                            onFocus: _ctx.onFocusItem,
                            "data-chapter-item": "",
                            chapter: chapter,
                            course: _ctx.course
                          }, null, 8, ["onFocus", "chapter", "course"])
                        ]))
                      }), 128))
                    ], 4)
                  ], 2)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onBeforeEnter", "onAfterEnter", "onAfterLeave"])
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}